var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"module-top"},[_c('span',[_vm._v(_vm._s(_vm.topText))]),_c('img',{attrs:{"src":require('@/assets/footer_logo.png'),"alt":"中国品牌日"}})])}
var staticRenderFns = []

export { render, staticRenderFns }